import { BannerSection, SectionSubtitle } from '@web_opxp/components';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/language';
import * as React from 'react';
import { AssetsBaseUrl } from '../../base/env';

export interface IProps {
  blogUrl: string;
  onLearnMore?: () => void;
}

const PartnersSection: React.FC<IProps> = ({ blogUrl, onLearnMore }) => {
  const { t } = useTranslation();
  const title = t('prereg:Welcome.PartnersSection.Title');
  const descriptionHtml = t('prereg:Welcome.PartnersSection.DescriptionHtml');
  const imgSrc = `${AssetsBaseUrl}/feature/partners.png`;
  return (
    <BannerSection direction="right" title={title} imgSrc={imgSrc}>
      <SectionSubtitle wrapperTag="div">{renderStringToReact(descriptionHtml, ETagType.div)}</SectionSubtitle>
      <a href={blogUrl} onClick={onLearnMore}>
        {t('prereg:Welcome.PartnersSection.Action')}
      </a>
    </BannerSection>
  );
};

export default PartnersSection;
